import { en } from './lang_en/lang_En';
import { by } from './lang_by/lang_By';
import { ru } from './lang_ru/lang_Ru';

const languages = {en, ru, by}

export default languages
